import { AppDefinition } from '../../types/apps';

export const VIDEO_STUDIO_EVENTS = {
  OPEN: 'VIDEO_STUDIO_OPEN',
  PLAY: 'VIDEO_STUDIO_PLAY',
  PAUSE: 'VIDEO_STUDIO_PAUSE',
  SPLIT: 'VIDEO_STUDIO_SPLIT',
  SEEK: 'VIDEO_STUDIO_SEEK',
  IMPORT: 'VIDEO_STUDIO_IMPORT',
  EXPORT: 'VIDEO_STUDIO_EXPORT',
} as const;

export const VideoStudioAppDefinition: AppDefinition = {
  appId: 'videostudio',
  name: 'Video Studio',
  version: '0.1.0',
  description:
    'Non-destructive timeline video editor with range-scoped AI operations. Supports multi-GB imports, cloud + local AI providers, and source-video-conditioned generation.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'FilmReel',
    phosphorWeight: 'duotone',
    color: '#ec4899',
    metadata: { source: 'app', appId: 'videostudio', isAppIcon: true },
  },
  entityIcons: {
    VideoProject: {
      type: 'phosphor',
      phosphorIcon: 'FilmReel',
      phosphorWeight: 'duotone',
      color: '#ec4899',
    },
    'File.Video': {
      type: 'phosphor',
      phosphorIcon: 'Video',
      phosphorWeight: 'fill',
    },
    'File.VideoProxy': {
      type: 'phosphor',
      phosphorIcon: 'Video',
      phosphorWeight: 'duotone',
    },
  },
  events: VIDEO_STUDIO_EVENTS,
  entityTypes: ['VideoProject'],
  supportedFileTypes: ['.mp4', '.webm', '.mov', '.avi', '.mkv', '.m4v'],
  searchableSkeletonFields: {
    VideoProject: ['name'],
  },
  component: 'VideoStudioApp',
  requiresProps: false,
  requiresEntity: true,
  isCore: true,
  experimental: true,
  // agenticToolIds is populated as the video_* tools ship (Phase F). Declaring
  // it here keeps the app's canonical tool catalog discoverable.
  agenticToolIds: [
    'video_project_create',
    'video_upscale',
    'video_denoise',
    'video_stabilize',
    'video_interpolate',
    'video_inpaint_region',
    'video_restyle',
    'video_extend',
    'video_variation',
    'video_generate_from_frame',
    'video_frame_export',
    'video_mask_track',
    'video_export',
  ],
  actions: {},
};
